(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('communication-status', {
            parent: 'entity',
            url: '/communication-status?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.communicationStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/communication-status/communication-statuses.html',
                    controller: 'CommunicationStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('communication-status-detail', {
            parent: 'entity',
            url: '/communication-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.communicationStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/communication-status/communication-status-detail.html',
                    controller: 'CommunicationStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('communicationStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommunicationStatus', function($stateParams, CommunicationStatus) {
                    return CommunicationStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('communication-status.new', {
            parent: 'communication-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-status/communication-status-dialog.html',
                    controller: 'CommunicationStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('communication-status', null, { reload: true });
                }, function() {
                    $state.go('communication-status');
                });
            }]
        })
        .state('communication-status.edit', {
            parent: 'communication-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-status/communication-status-dialog.html',
                    controller: 'CommunicationStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommunicationStatus', function(CommunicationStatus) {
                            return CommunicationStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('communication-status.delete', {
            parent: 'communication-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/communication-status/communication-status-delete-dialog.html',
                    controller: 'CommunicationStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommunicationStatus', function(CommunicationStatus) {
                            return CommunicationStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('communication-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
